var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dflex-cont dflex-cont_column_center"},[_c('Banner',{staticClass:"dflex-child_maxwidth",attrs:{"text":"Продукты","image":"products.svg"}}),_c('ProductList',{staticClass:"dflex-child_maxwidth"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }